export default "__VITE_ASSET__C_A3lO7c__"